import PropTypes from "prop-types";

import styles from "./FlexItem.module.css";

const FlexItem = (props) => {
  return (
    <div className={styles.flexItem} style={{ ...props.style }}>
      {props.children}
    </div>
  );
};

FlexItem.defaultProps = {};

FlexItem.propTypes = {
  children: PropTypes.node,
};

export default FlexItem;
